/***
 *
 *   TOGGLE STYLES
 *   A two-option segmented control. Matches the shape of the reference's
 *   ViewToggle (ui-reference/src/components/tickets/view-toggle.tsx): a
 *   bordered h-9 track with the active segment tinted primary-100.
 *
 **********/

const Style = {
    container: 'inline-flex h-9 w-fit shrink-0 cursor-pointer items-center gap-0.5 rounded-md border bg-surface px-0.5',
    first: 'h-8 rounded-sm px-3 text-xs font-medium text-text-secondary transition-colors duration-150 hover:bg-primary-50 dark:hover:bg-primary-900/40',
    second: 'h-8 rounded-sm px-3 text-xs font-medium text-text-secondary transition-colors duration-150 hover:bg-primary-50 dark:hover:bg-primary-900/40',
    selected: 'bg-primary-100 text-primary-700 dark:bg-primary-900/50 dark:text-primary-200',
};

export default Style;
